module.exports = __webpack_public_path__ + "img/hondacrv.4627995e.png";